import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import Carrusel from '../_app/cuchillo/components/Carrusel';
import InstagramPostStory from '../_app/cuchillo/components/InstagramPostStory';
import FormSender from '../_app/cuchillo/forms/FormSender';
import gsap, { Expo } from 'gsap';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Maths } from '../_app/cuchillo/utils/Maths';

class ScrollItem__AboutHeader extends VScroll_Item {
  
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);
    this._titles = GetBy.class("title", this.item);
    this.holder = GetBy.class("holder", this.item)[0];
    this.holder.style.setProperty('--offset', `${-Maths.maxminRandom(110, 50)}%`);

    /*this._carrusel = new Carrusel(Metrics.WIDTH, this._titles[0],this._titles[1]);
    this._carrusel.fixedDirection = true;
    this._carrusel.multiplicator = 2;
    this._carrusel.minVel = 0;
    
    this._call = () => this.loop();
    this.onShow = () => {
        gsap.to(this.holder,{y:0, duration:1, ease:Expo.easeOut, force3D:true});
        gsap.ticker.add(this._call);
    };

    this.onHide = () => {};*/
  }

  resize(w,h) {
      super.resize(w,h);
      if(this._carrusel) this._carrusel.resize(Metrics.WIDTH);
  }

  loop() {
      if(this._carrusel) this._carrusel.loop();
  }

  dispose() {
    //gsap.ticker.remove(this._call);
    if(this._carrusel) this._carrusel.dispose();
    super.dispose();
  }
}

Scroll._registerClass('about-header', ScrollItem__AboutHeader);
